import { useState } from 'react';
import { Alert, Box, Button, Divider, Stack, Typography } from '@mui/material';
import { passwordReset } from '../../auth/slice';
import { useAppDispatch, useAppSelector } from '@/hooks';

const ChangePassword = () => {
  const [emailSent, setEmailSent] = useState(false);
  const dispatch = useAppDispatch();

  const profile = useAppSelector((state) => state.auth.user);

  const handleResetPassword = async () => {
    if (!profile?.email) return;
    await dispatch(passwordReset(profile?.email));
    setEmailSent(true);
  };

  return (
    <Box
      sx={{
        width: '-webkit-fill-available',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Stack gap={4}>
        <Typography variant="h1">Cambiar mi Contraseña</Typography>
        <Divider />
        {emailSent ? (
          <Alert color="success" severity="success">
            Email sent, check your inbox!
          </Alert>
        ) : null}
        <Typography variant="h3">Name: {profile?.name}</Typography>
        <Typography variant="h3">Lastname: {profile?.lastname}</Typography>
        <Typography variant="h3">Email: {profile?.email}</Typography>
        <br />
        <Button
          variant="contained"
          onClick={handleResetPassword}
          size="large"
          fullWidth
        >
          Cambiar Contraseña
        </Button>
      </Stack>
    </Box>
  );
};

export default ChangePassword;
